class K1ModalRecall {
	body = document.querySelector("body");

	constructor(params) {
		this.openModalButton = params.openModalButton
		this.modal = params.modal
		this.buttonClose = params.buttonClose
		this.buttonSend = params.buttonSend
		this.phone = params.phone
		this.name = params.name
		this.checkbox = params.checkbox 
	};

	init() {
		this.bindElements()
		// Добавляем обработчик для чекбокса согласия
		
		if (this.checkbox && this.buttonSend) {
			this.checkbox.addEventListener('change', () => {
				if (this.checkbox.checked) {
					this.buttonSend.classList.remove('disabled');
				} else {
					this.buttonSend.classList.add('disabled');
				}
			});

			// Инициализация состояния кнопки при загрузке
			if (!this.checkbox.checked) {
				this.buttonSend.classList.add('disabled');
			} else {
				this.buttonSend.classList.remove('disabled');
			}
		}
	};

	bindElements() {
		this.openModalButton.forEach(button => {
			BX.bind(button, "click", BX.proxy(this.openModal, this))
		}, this)

		BX.bind(this.modal, "click", BX.proxy(this.closeModal, this))
		BX.bind(this.buttonSend, "click", BX.proxy(this.sendModalData, this))


	};

	hideError(elem) {
		if (elem.target.closest(".k1-error")) {
			elem.target.closest(".k1-error").classList.remove("k1-error")
		}
	};

	openModal() {
		this.body.style.overflow = "hidden"
		this.modal.style.display = "flex"
	};

	getModalData() {
		let data = {}
		let error = false

		if (this.phone.value[0] == '8') {
			if (this.phone.value.length < 17) {
				window.k1Forms.setError(this.phone, true)
				BX.bind(this.phone, "input", BX.delegate(this.hideError, this))
				error = true
			} else {
				window.k1Forms.setError(this.phone, false)
				BX.unbind(this.phone, "input", BX.delegate(this.hideError, this))
				data.RECALL_FORM_PHONE = this.phone.value
				error = false
			}
		}

		if (this.phone.value[0] == '+') {
			if (this.phone.value.length < 18) {
				window.k1Forms.setError(this.phone, true)
				BX.bind(this.phone, "input", BX.delegate(this.hideError, this))
				error = true
			} else {
				window.k1Forms.setError(this.phone, false)
				BX.unbind(this.phone, "input", BX.delegate(this.hideError, this))
				data.RECALL_FORM_PHONE = this.phone.value
				error = false
			}
		}

		if (this.name.value.length < 2) {
			window.k1Forms.setError(this.name, true)
			BX.bind(this.name, "input", BX.delegate(this.hideError, this))
			error = true
		} else {
			window.k1Forms.setError(this.name, false)
			BX.bind(this.name, "input", BX.delegate(this.hideError, this))
			data.RECALL_FORM_NAME = this.name.value
			error = false
		}

		// if (this.modal.querySelector("[name='g-recaptcha-response']")) {
		// 	data.recaptcha = this.modal.querySelector("[name='g-recaptcha-response']").value
		// }

		if (!error) {
			data.time = new Date().toLocaleDateString()
		}

		return data
	};

	closeModal(event) {
		const target = event.target
		if (target === this.buttonClose || !target.closest(".modal__body")) {
			this.modal.style.display = "none"
			this.body.style.overflow = "auto"
		}

	};

	sendModalData() {
		console.log('123');
		const url = "/ajax/modal-recall.php"
		if (this.phone.value != '' && this.name.value != '') {
			grecaptcha.ready(() => {
				grecaptcha.execute(
					document.querySelector('meta[name="google-recaptcha"]').content,
					{ action: 'order_call' }
				).then((token) => {
					let dataForm = this.getModalData()
					dataForm.recaptcha = token

					fetch(url, {
						method: "post",
						headers: {
							"Content-Type": "application/json"
						},
						body: JSON.stringify(dataForm)
					}).then(response => {
						return response.text()
					}).then(data => {
						let response = JSON.parse(data)
						this.name.value = ''
						this.phone.value = ''
						this.modal.style.display = "none"
						this.body.style.overflow = "auto"

						if (response.status === true)
							console.log('good form action')
							// $('.modal-installments-js').addClass('success');
							$('.bg_modal_custom').addClass('active');
							ym(9755971,'reachGoal','zakazat-zvonok')
							$('body').css('overflow','hidden');
							// $('.modal.modal-fast-buy-js').css('display','block');
							setTimeout(() => {
								// Код для задержки на 5 секунд
								// $('.recall_modal.modal-fast-buy__success').removeClass('active');
								// $('.recall_modal.modal-fast-buy-js ').removeClass('opened');
								// $('body').css('overflow','visible');
								// $('.modal.modal-fast-buy-js').css('display','none');
								$('.bg_modal_custom').removeClass('active');
								$('body').css('overflow','visible');
							}, 5000);

					})
				})
			})
		} else {
			this.getModalData()
		}
	};
}



new K1ModalRecall({
	openModalButton: document.querySelectorAll(".open-modal-recall-js"),
	modal: document.querySelector(".modal-recall"),
	buttonClose: document.querySelector(".modal-recall .modal__close"),
	buttonSend: document.querySelector(".modal-recall .modal-form-button-js"),
	phone: BX("modal-recall-phone"),
	name: BX("modal-recall-name"),
	checkbox: BX("modal-recall-agree"),
}).init()


$('.bg_modal_custom').on('click', function() {
	$('.bg_modal_custom').removeClass('active');
	$('body').css('overflow','visible');
});
